import { EnvironmentConfig } from '@trtl/portal/env';

export const environment: EnvironmentConfig = {
  production: true,
  api: {
    admin: 'https://portal.api.test.trtl.health/api/v1/admin',
    doctor: 'https://portal.api.test.trtl.health/api/v1/doctor',
    public: 'https://portal.api.test.trtl.health/api/v1/public',
    patient: 'https://portal.api.test.trtl.health/api/v1/patient',
  },
  ws: 'ws://api.test.trtl.health',
  sentry: {
    dsn: 'https://471dbd95432d3dda9eb56cbfb18e23a6@o4508120270372864.ingest.de.sentry.io/4508120634163280',
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /https:\/\/[^.]+\.test\.trtl\.health/],
  },
  environment: 'test',
  trtl: 'https://trtl.health',
};
